// src/utils/scene/computeSafeSceneBox.js
//
// NaN-tolerant sahne bounding box hesaplama.
// Bazi entity'ler NaN pozisyonlu geometry uretir; bunlari atlayarak
// guvenli bir bbox dondurur.

import * as THREE from 'three';

export function computeSafeSceneBox(scene) {
  const box = new THREE.Box3();
  let skipped = 0, included = 0;
  scene.traverse((child) => {
    if (!(child.isMesh || child.isLine || child.isLineSegments)) return;
    const geom = child.geometry;
    if (!geom) return;
    if (!geom.boundingBox) {
      try { geom.computeBoundingBox(); } catch { return; }
    }
    const b = geom.boundingBox;
    if (!b) return;
    if (!Number.isFinite(b.min.x) || !Number.isFinite(b.min.y) ||
        !Number.isFinite(b.max.x) || !Number.isFinite(b.max.y)) {
      skipped += 1;
      return;
    }
    const world = b.clone().applyMatrix4(child.matrixWorld);
    if (!Number.isFinite(world.min.x) || !Number.isFinite(world.min.y) ||
        !Number.isFinite(world.max.x) || !Number.isFinite(world.max.y)) {
      skipped += 1;
      return;
    }
    box.union(world);
    included += 1;
  });
  return box;
}
